import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): ReactNode {
  return (
    <section className="flex flex-col items-start gap-4 py-16">
      <p className="text-muted-foreground text-sm uppercase tracking-widest">404</p>
      <h1 className="text-3xl font-bold tracking-tight">Page not found</h1>
      <p className="text-muted-foreground">
        The page you were looking for doesn’t exist (or hasn’t been built yet).
      </p>
      <Link to="/" className="text-primary text-sm underline">
        Back to home
      </Link>
    </section>
  );
}
